var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonFooterMembership.jinja');
require('./CommonFooterMembership.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonFooterMembership/CommonFooterMembership.js
// module id = 24
// module chunks = 0